"use strict";

const {GSNDevProvider, GSNProvider} = require("@openzeppelin/gsn-provider");
const {makeEngine, makeBaseProvider} = require("./");

module.exports = (signingProvider, dataProvider) => {
  const dataProviderMiddleware = makeBaseProvider(dataProvider).asMiddleware();
  const signingProviderEthers = makeBaseProvider(signingProvider).asEthers();
  const engine = makeEngine();
  engine.push(async (req, res, next, end) => {
    try {
      if (
        [
          "eth_accounts",
          "eth_sendTransaction",
          "eth_sign",
          "personal_sign",
          "eth_signTypedData",
          "eth_signTypedData_v3"
        ].includes(req.method)
      ) {
        try {
          res.result = await signingProviderEthers.send(req.method, req.params);
        } catch (e) {
          res.error = e;
        }
        end();
      } else next();
    } catch (e) {
      res.error = e;
      end();
    }
  });
  engine.push(dataProviderMiddleware);
  const provider2 = engine.asProvider();
  const resultProvider = makeBaseProvider(new GSNProvider(provider2));
  resultProvider.baseProvider = makeBaseProvider(signingProvider);
  return resultProvider;
};
